import React from 'react';
import {Redirect, useLocation} from 'react-router-dom';
import {includes} from 'lodash';
import connectCollegeEarnings from 'shared/college-earnings/containers/college-earnings';
import CollegeEarnings from 'high-school-student/college-earnings/components/college-earnings';
import {useMediaQuery} from 'src/hooks/useMediaQuery';

const ConnectedCollegeEarnings = connectCollegeEarnings(CollegeEarnings);

const PortfolioSidebar = () => {
  const mq = useMediaQuery();
  const location = useLocation();

  if (mq.MD_AND_UP && includes(location.pathname, 'following')) {
    return <Redirect to="/portfolio" />;
  } else if (mq.MS_AND_DOWN && !includes(location.pathname, 'following')) {
    return null;
  }

  return (
    <div className="portfolio-sidebar high-school-student">
      <ConnectedCollegeEarnings />
    </div>
  );
};

export default PortfolioSidebar;
